// Enum for users roles

export const USER_ROLES = {
    "ADMIN": "Administrador",
    "GERENTE": "Gerente",
    "USUARIO": "Usuário",
    "BASIC": "Básico"
}
